import {
  useProductStore,
  useProductStoreActions,
} from '../stores/product.store'
import { useGetProductFromOrderHook } from './use-get-product-from-order.hook'
import { useGetSearchProductHook } from './use-get-search-product.hook'

export const useProductDetailsHook = () => {
  const { product: searchProduct } = useGetSearchProductHook()
  const { product: productFromOrder } = useGetProductFromOrderHook()

  const product = productFromOrder || searchProduct

  const { isOpenModalDetailsProduct: isOpenDetails } = useProductStore()

  const { setIsOpenModalDetailsProduct: setIsOpenDetails } =
    useProductStoreActions

  const handleCloseDetails = () => {
    setIsOpenDetails(false)
  }

  const modalProps = {
    isOpenDetails,
    onCloseDetails: handleCloseDetails,
  }

  const productDetails = {
    productImage: product?.produto?.imagem,
    productDescription: product?.produto?.descricao,
    cubagem: product?.produto?.cubagem,
    pesoLiquido: product?.produto?.pesoLiquido,
		porcComissao: product?.porcComissao,
    pesoBruto: product?.produto?.pesoBruto,
    pesoEmbalagem: product?.produto?.flagPesoPorEmbalagem,
    qtdeEmbalagem: product?.produto?.qtdeEmbalagem,
    qtdEmbMaster: product?.produto?.qtdeEmbalagemMaster,
    altura: product?.produto?.altura,
    largura: product?.produto?.largura,
    comprimento: product?.produto?.comprimento,
  }
  return {
    modalProps,
    productDetails,
  }
}
